import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

import { computed, ref } from 'vue'
import type { RewardCardType, RewardPurchasePayload } from '@/types'
import { useTr } from '@/composables/use-tr'
import Typography from '@/components_new/Typography.vue'
import Button from '@/components_new/Button.vue'
import CardCarousel from '@/components_new/CardCarousel.vue'
import { formatValue } from '@/utils/numbers'
import RewardCard from './RewardCard.vue'
import { useUserStore } from '@/store/user-store/user-store'
import { useLayoutStore } from '@/store/layout-store'
import RewardPurchaseModal from './RewardPurchaseModal.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'RewardsCards',
  props: {
    rewards: {},
    purchaseReward: { type: Function }
  },
  setup(__props: any) {

const props = __props

const tr = useTr()

const availabilityLabels = computed(() => ({
    low: tr('rewards.availability_low'),
    medium: tr('rewards.availability_medium'),
    high: tr('rewards.availability_high'),
}))

const userStore = useUserStore()
const layoutStore = useLayoutStore()
const purchaseDialogState = ref<
    { card: RewardCardType; email: string; country: { code: string; nameEn: string } } | undefined
>(undefined)

function getPurchaseInterfaceTarget(item: RewardCardType) {
    if (!userStore.isAuthorized) {
        return 'open-sign-in-modal'
    }
    if (userStore.userBalance < item.price) {
        return 'open-need-more-fennecs-modal'
    }
    return 'open-purchase-modal'
}

function onCardClick(item: RewardCardType) {
    if (userStore.isAuthorized) {
        if (userStore.userBalance >= item.price) {
            const locale = window.additionalServerData?.locale
            purchaseDialogState.value = {
                card: item,
                email: userStore.user?.email || 'unknown email', // TODO i18n, goes to Backend and UI,
                country: {
                    code: locale?.countryCode || 'unknown-country', // goes to Backend, no need for i18n
                    nameEn: locale?.countryNameEn || tr('rewards.purchase_dialog_unknown_country'),
                },
            }
        } else {
            layoutStore.setInviteModalOpened('need_more_fennecs')
        }
    } else {
        layoutStore.setSignInModalOpened(true)
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.cards)
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.rewards, (group, groupIndex) => {
        return (_openBlock(), _createBlock(CardCarousel, {
          key: groupIndex,
          class: _normalizeClass(_ctx.$style.cards_group),
          items: group
        }, {
          default: _withCtx(({ item, className, bigCardClassName }) => [
            _createElementVNode("div", {
              class: _normalizeClass([_ctx.$style.cards_item, className, bigCardClassName])
            }, [
              _createVNode(RewardCard, {
                type: item.type,
                value: item.value,
                currency: item.currency,
                class: _normalizeClass(_ctx.$style.card),
                onClick: ($event: any) => (onCardClick(item))
              }, null, 8, ["type", "value", "currency", "class", "onClick"]),
              _createVNode(Typography, {
                class: _normalizeClass([_ctx.$style.card_availability, _ctx.$style['card_availability_' + item.availability]]),
                size: "s",
                accent: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString('● ' + availabilityLabels.value[item.availability]), 1)
                ]),
                _: 2
              }, 1032, ["class"]),
              _createVNode(Button, {
                class: _normalizeClass(_ctx.$style.card_button),
                interfaceTarget: getPurchaseInterfaceTarget(item),
                iconLeft: "silver_fennec_coin_small",
                size: "l",
                color: "purple-graphite",
                width: "full",
                onClick: ($event: any) => (onCardClick(item))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(formatValue)(item.price)), 1)
                ]),
                _: 2
              }, 1032, ["class", "interfaceTarget", "onClick"])
            ], 2)
          ]),
          _: 2
        }, 1032, ["class", "items"]))
      }), 128))
    ], 2),
    _createVNode(RewardPurchaseModal, {
      purchase: purchaseDialogState.value,
      doPurchase: props.purchaseReward,
      onCloseModal: _cache[0] || (_cache[0] = ($event: any) => (purchaseDialogState.value = undefined))
    }, null, 8, ["purchase", "doPurchase"])
  ]))
}
}

})